import { IRole } from '@app/models/role.interface';
import { createAction, props } from '@ngrx/store';

export const loadRoles = createAction(
  '[Role] Load Roles'
);

export const loadRolesSuccess = createAction(
  '[Role] Load Roles Success',
  props<{ roles: IRole[], total: number }>()
);

export const loadRolesFailure = createAction(
  '[Role] Load Roles Failure',
  props<{ error: any }>()
);

export const loadRole = createAction(
  '[Role] Load Role',
  props<{id: number }>()
);

export const loadRoleSuccess = createAction(
  '[Role] Load Role Success',
  props<{ role: IRole }>()
);



export const loadRoleFailure = createAction(
  '[Role] Load Role Failure',
  props<{ error: any }>()
);

export const saveRole = createAction(
  '[Role] Save Role',
  props<{ role: any }>()
)

export const saveRoleSuccess = createAction(
  '[Role] Save Role Success',
  props<{ role: any }>()
)

export const saveRoleFailure = createAction(
  '[Role] Save Role Failure',
  props<{error: any}>()
)

export const updateRole = createAction(
  '[Role] Update Role',
  props<{
    id: any, 
    role: any }>()
)

export const updateRoleSuccess = createAction(
  '[Role] Update Role Success',
  props<{ role: any }>()
)

export const updateRoleFailture = createAction(
  '[Role] Update Role Failure',
  props<{ error: any }>()
)

export const deleteRole = createAction(
  '[Role] Delete Role',
  props<{
    id: any
  }>()
)

export const prepareDeleteRole = createAction(
  '[Role] Prepare Delete Role',
  props<{
    id: any
  }>()
)

export const deleteRoleSuccess = createAction(
  '[Role] Delete Role Success',
  props<{ id: any }>()
)

export const deleteRoleFailure = createAction(
  '[Role] Delete Role Failure'
)

export const DeleteRoleShowErrorMessage = createAction(
  '[Error] Delete Role Show Error Message',
  props<{ user_count: number,current_role_id: number, role_list: any}>()
)

export const AssignNewRoles = createAction(
  '[Error] Assing User to New Role',
  props<{ current_role_id: number, new_role_ids: number,}>()
)

export const checkRole = createAction(
  '[Role] Check Role',
  props<{
    name: string
  }>()
)

export const checkRoleSuccess = createAction(
  '[Role] Check Role Success',
  props<{ valid: any }>()
)

export const checkRoleFailure = createAction(
  '[Role] Check Role Failure'
)

export const sortRoles = createAction(
  '[Role] Sort Roles',
  props<{ sort: any, direction: any }>()
)

export const incrementPage = createAction(
  '[Role] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[Role] Reset Pagination'
);

export const incrementPageSuccess = createAction(
  '[Role] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Role] Decrement Pagination'
);

export const resetRole = createAction(
  '[Role] Reset Role'
);